import { render, staticRenderFns } from "./Projet.vue?vue&type=template&id=0f44f077&scoped=true&"
import script from "./Projet.vue?vue&type=script&lang=js&"
export * from "./Projet.vue?vue&type=script&lang=js&"
import style0 from "./Projet.vue?vue&type=style&index=0&id=0f44f077&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f44f077",
  null
  
)

export default component.exports